import Graph from '../Graph/Graph';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import './About.css';

const SKILLS = {
  Languages:      ['C#/.NET', 'JavaScript', 'TypeScript', 'Python', 'SQL', 'HTML/CSS'],
  Frontend:       ['React', 'Next.js', 'Tailwind CSS'],
  Backend:        ['Node.js', 'Express', 'REST APIs', 'GraphQL'],
  'Data & Cloud': ['SQL Server', 'Azure', 'Application Insights', 'Terraform', 'PostgreSQL'],
  Integration:    ['Boomi', 'NetSuite', 'CI/CD Pipelines', 'Docker'],
  AI:             ['CrewAI', 'OpenAI', 'Claude API', 'LLM Orchestration'],
};

const About = () => {
  const headerRef  = useScrollReveal();
  const bioRef     = useScrollReveal();
  const chartRef   = useScrollReveal();

  return (
    <section id="about" className="about" aria-label="About Me">
      <div className="section-container">
        <div className="section-header reveal" ref={headerRef}>
          <p className="section-label">Background</p>
          <h2 className="section-title">About Me</h2>
        </div>

        <div className="about__grid">
          <div className="about__bio reveal" ref={bioRef}>
            <p>
              As <strong>Software Engineer II at BioTouch</strong>, I lead full-stack development
              for laboratory order processing systems that handle high-volume operations across the
              country. I architect integrations between NetSuite, web platforms, and printing
              systems using Boomi middleware, and spearhead security implementations for a
              6-person development team.
            </p>
            <p>
              My specialty is making legacy systems work harder: optimizing SQL queries that handle
              millions of rows, building API integrations that process bulk invoice data, and
              migrating outdated codebases to modern stacks without disrupting production. I've
              spent the last year deep in performance tuning, Azure deployments, and the kind of
              debugging that requires both patience and a stubborn refusal to give up.
            </p>
            <p>
              Before BioTouch, I built custom automations and AI applications for healthcare
              systems at <strong>Olive AI</strong>, focusing on security protocols and workflow
              efficiency. I also taught web development and algorithms at the{' '}
              <strong>University of Oregon</strong> — because the best way to stay sharp is to
              explain your thinking to someone else.
            </p>

            <div className="about__skills">
              {Object.entries(SKILLS).map(([category, items]) => (
                <div key={category} className="about__skill-group">
                  <h4 className="about__skill-category">{category}</h4>
                  <div className="about__skill-tags">
                    {items.map((skill) => (
                      <span key={skill} className="about__skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="about__chart reveal reveal-d2" ref={chartRef}>
            <Graph />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
